import { render, staticRenderFns } from "./AcquisitionBatchCreateEdit.vue?vue&type=template&id=606e33f6&scoped=true&"
import script from "./AcquisitionBatchCreateEdit.vue?vue&type=script&lang=js&"
export * from "./AcquisitionBatchCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./AcquisitionBatchCreateEdit.vue?vue&type=style&index=0&id=606e33f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e33f6",
  null
  
)

export default component.exports